<template>
  <v-container v-if="$checkPermission('number_of_teachers_by_canton')" :class="{'v3_index_view':  $vuetify.breakpoint.mdAndUp, 'pa-0': $vuetify.breakpoint.smAndDown}">
    <v-row class="mx-0" :class="{'v3_heading_mobile_view': $vuetify.breakpoint.smAndDown}">
      <v-col cols="8" md="6" class="pt-6 pb-6">
            <span class="headline font-weight-light">
                   Broj profesora po školama
                   <v-icon slot="divider" @click="getData()" style="padding-bottom: 2px;">mdi-refresh</v-icon>
                </span>

      </v-col>
      <v-col cols="4" md="6" align="right">
        <v-tooltip bottom color="primary">
          <template v-slot:activator="{ on }">
            <v-btn icon large class="ml-5" align="right" @click="exportDataExcel()">
              <v-icon large color="primary" dark v-on="on">
                mdi-microsoft-excel
              </v-icon>
            </v-btn>
          </template>
          <span>Izvoz podataka u Excel</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row class="mx-0" :class="{'v3_heading_mobile_view': $vuetify.breakpoint.smAndDown}">
      <v-col cols="12" md="4">
        <v-text-field
            outlined

            label="Pretraga"
            v-model="search"
            hide-details
            dense
            prepend-inner-icon="mdi-magnify"
        ></v-text-field>
      </v-col>

      <v-col cols="12" md="4">
        <v-autocomplete

            v-if="true"
            outlined
            :items="cantons.items"
            item-text="title"
            item-value="id"
            hide-details
            label="Odaberi županiju..."
            v-model="select_canton"
            dense
            @change="getDataTable()"
            :disabled="role == 2 ? true : false"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="4">
        <v-autocomplete
            outlined
            :items="school_years.items"
            item-text="title"
            item-value="id"
            hide-details
            label="Odaberi školsku godinu..."
            v-model="select_school_year"
            dense
            @change="getDataTable()"
        ></v-autocomplete>
      </v-col>


      <v-col cols="12">
        <v-data-table
            :headers="headers"
            :items="dataTable"
            :search="search"
            class="elevation-1"
            loading-text="Traženje..."
            :footer-props="{itemsPerPageText: 'Redaka po stranici:'}"
            :header-props="{sortByText: 'Poredaj po'}">
          <template v-slot:[`item.teacher_subjects`]>
            <span style="color: #084776">{{ select_subject_title }}</span>
          </template>
          <template v-slot:no-data>
            <span>
                Za tražene pojmove nema rezultata pretrage.
            </span>
          </template>

          <template v-slot:footer.page-text="items"> Prikazano {{ items.pageStart }} do {{ items.pageStop }} od ukupno
            {{ items.itemsLength }} rezultata
          </template>

          <template v-slot:[`item.actions`]="{ item }">

            <v-btn color="primary" @click="showAllProfessors(item)">
              <v-tooltip color="primary" bottom
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-on="on" v-bind="attrs"
                  >mdi-magnify
                  </v-icon
                  >
                </template
                >
                Pregled profesora u skoli
              </v-tooltip
              >
            </v-btn>

          </template>
        </v-data-table>
      </v-col>
    </v-row>


  </v-container>
</template>

<script>
import apiV2 from "../../services/ApiV2";
export default {
  name: "TeachersInCanton",
  data() {
    return {
      show_add_view: false,
      show_table_view: false,
      dataTable: [],
      headers: [
        {
          text: "Naziv skole",
          value: "school_name",
        },
        {
          text: "Broj nastavnika",
          value: "user_count",
        },
        {
          text: "Akcija",
          value: "actions",
          sortable: false,
        }

      ],
      search: "",
      select_canton: "",

      cantons: {},
      school_years: {},
      select_school_year: "",
      role: null


    };
  },
  mounted() {
    this.getData();
    this.role = localStorage.getItem('role_id');
  },
  methods: {
    async exportDataExcel() {
        const response =  await apiV2.get('count_teachers_per_cantons_and_schools/export', {
          params: {
            canton_id: this.select_canton,
            school_year_id: this.select_school_year
          },
          responseType: 'blob'
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));

        const link = document.createElement('a');
        link.href = url;

        link.setAttribute('download', 'Broj nastavnika po školama.xlsx');
        document.body.appendChild(link);

        link.click();
        window.URL.revokeObjectURL(url);
    },
    getData() {
      this.getCantons();
      this.getSchoolYears();
    },
    getDataTable() {
      let data = {
        'canton_id': this.select_canton,
        'school_year': this.select_school_year,
      }
      this.$axios.post('ostalo/izvjestaj/broj_nastavnika_po_skolama_god', data)
          .then((response) => {
            this.dataTable = response.data
          })
    },
    getCantons() {
      this.$axios.post('zupanija').then((response) => {
        this.cantons = response.data;
        if (this.role == 2) {
          this.select_canton = parseInt(localStorage.getItem('organisation_id'));
          this.getDataTable()
        } else if (this.select_canton === "") {
          this.select_canton = this.cantons.items[0].id;
          this.getDataTable()
        }

      })
    },
    getSchoolYears() {
      this.$axios.post('skolska_godina').then((response) => {
        this.school_years = response.data;
        if (this.select_school_year === "") {
          console.log(this.school_years)
          let activeSchoolYears = this.school_years.items.filter(item => item.active === "Da");
          console.log(activeSchoolYears);


          this.select_school_year = activeSchoolYears[0].id;
          console.log(this.select_school_year);
          this.getDataTable();

        }
      });
    },
    showAllProfessors(item) {
      this.$router.push({
        path: '/admin/izvjestaj/profesori_po_zupanijama_popis',
        query: {school: item.school_id, year: this.select_school_year}
      });
    },
  }
}
</script>

<style scoped>

</style>